import request from '@/utils/request'
const BASE_URL = '/wx/manual'

export default {
  getCountInfo() {
    return request({
      url: BASE_URL + '/countinfo',
      method: 'get',
    })
  },
  getManual(params) {
    return request({
      url: BASE_URL,
      method: 'get',
      params
    })
  },
  postManual(data) {
    return request({
      url: BASE_URL,
      method: 'post',
      data
    })
  },
  putManual(data) {
    return request({
      url: BASE_URL,
      method: 'put',
      data
    })
  },
  delManual(data) {
    return request({
      url: BASE_URL,
      method: 'delete',
      data
    })
  },
}